import type {TranslationFunction} from 'src/types/language-support';

import {MAX_WIDGETS} from 'src/components/analytics-genesis/byod/constants';


export function getWidgetLimitTooltipBody(t: TranslationFunction): string {
  return t('Widget_limit_tooltip', {
    max: MAX_WIDGETS,
    defaultValue: 'There is a limit of adding up to {{max}} reports',
  });
}
